import { useTranslation } from 'react-i18next';
import { PostProcessKeys, TranslationKeys } from 'translations';
import { OptionType } from 'v2/form/CustomSelectors/GeneralSelect';
import { DrmEntityBackend } from 'v2/models';
import { BulkImportType } from './formSteps/FileSelection/hooks';

export type GroupedEntityOptions = {
  label: 'Required *' | 'Optional';
  options: OptionType[];
};

export type EntityOptions = Record<BulkImportType, Array<GroupedEntityOptions>>;

export const drmPageEntityMapping: Record<
  BulkImportType,
  DrmEntityBackend | undefined
> = {
  [BulkImportType.DATA_VENDOR]: DrmEntityBackend.DATA_VENDOR,
  [BulkImportType.CONTACT]: DrmEntityBackend.CONTACT,
  [BulkImportType.DATASET]: DrmEntityBackend.DATASET,
  [BulkImportType.FILE]: undefined,
};

export function useEntityOptions() {
  const { t } = useTranslation();

  const entityOptions: EntityOptions = {
    [BulkImportType.DATA_VENDOR]: [
      {
        label: 'Required *',
        options: [
          {
            label: 'Domain *',
            value: 'domain *',
          },
        ],
      },
      {
        label: 'Optional',
        options: [
          {
            label: `${t(TranslationKeys.company_one, {
              postProcess: PostProcessKeys.TitleCase,
            })} Name`,
            value: 'name',
          },
          {
            label: `${t(TranslationKeys.company_one, {
              postProcess: PostProcessKeys.TitleCase,
            })} Type`,
            value: 'classification',
          },
          {
            label: 'Description',
            value: 'description',
          },
        ],
      },
    ],
    [BulkImportType.DATASET]: [
      {
        label: 'Required *',
        options: [
          {
            label: `${t(TranslationKeys.dataProduct_one, {
              postProcess: PostProcessKeys.TitleCase,
            })} Name *`,
            value: 'name *',
          },
        ],
      },
      {
        label: 'Optional',
        options: [
          {
            label: 'Description',
            value: 'description',
          },
        ],
      },
    ],
    [BulkImportType.CONTACT]: [
      {
        label: 'Required *',
        options: [
          {
            label: 'Email *',
            value: 'email *',
          },
        ],
      },
      {
        label: 'Optional',
        options: [
          {
            label: 'First Name',
            value: 'first_name',
          },
          {
            label: 'Last Name',
            value: 'last_name',
          },
          {
            label: 'Title',
            value: 'title',
          },
        ],
      },
    ],
    [BulkImportType.FILE]: [],
  };

  return entityOptions;
}
